import { IConfigsType } from '../../types'

const dhBenchmarkingProductMix: IConfigsType = {
  mwb: {
    '/:brand/drive_thru': {
      disableAutoMargin: true,
      feV2: {
        type: 'FE V2',
        configPath: 'mwb/drive_thru',
        height: '1000px',
      },
    },
  },
}

export default dhBenchmarkingProductMix
